
        import * as module0 from './controllers/hero_controller.js';import * as module1 from './controllers/slider_controller.js'
        const modules = {
            "./controllers/hero_controller.js": module0,
            "./controllers/slider_controller.js": module1,
        };
        export default modules;
      